export default "__VITE_ASSET__25c08889__"